import { FC, memo } from 'react';
import { Controller, FormProvider } from 'react-hook-form';
import { Button, CheckboxCheckedChangeDetails, Stack } from '@chakra-ui/react';

import { Dialog, FormField, Input } from '~/core/shared/components';
import { Checkbox } from '~/core/shared/lib/chakraUi/components/Checkbox';
import { MODAL_DESCRIPTION } from './constants';
import { useBankStatementsBrokerForm } from './hooks';
import { BankStatementsBrokerModalProps } from './types';

const BankStatementsBrokerModalComponent: FC<
  BankStatementsBrokerModalProps
> = ({ modalApi, uuid, definition, withSync = false, onSuccess }) => {
  const { form, isLoading, onSubmit } = useBankStatementsBrokerForm(modalApi, {
    onSuccess,
    uuid,
    definition,
  });

  return (
    <Dialog
      header="Broker Document ID"
      onOpenChange={modalApi.onOpenChange}
      open={modalApi.open}
      subHeader={MODAL_DESCRIPTION}
    >
      <FormProvider {...form}>
        <Stack asChild gap={4}>
          <form onSubmit={onSubmit}>
            <FormField
              component={Input}
              label="Broker Document ID"
              name="brokerDocumentId"
              placeholder="Enter Broker Document ID"
              required
            />

            {withSync && (
              <Controller
                control={form.control}
                name="sync"
                render={({ field }) => (
                  <Checkbox
                    checked={field.value}
                    onCheckedChange={(details: CheckboxCheckedChangeDetails) =>
                      field.onChange(details.checked === true)
                    }
                  >
                    Retrieve synchronously
                  </Checkbox>
                )}
              />
            )}

            <Stack direction="row" justifyContent="end">
              <Button
                colorPalette="gray"
                fontSize="md"
                fontWeight="normal"
                onClick={modalApi.onClose}
                type="button"
                variant="outline"
              >
                Cancel
              </Button>
              <Button
                colorPalette="primary"
                fontSize="md"
                fontWeight="bold"
                loading={isLoading}
                onClick={onSubmit}
                type="button"
                variant="solid"
              >
                Submit
              </Button>
            </Stack>
          </form>
        </Stack>
      </FormProvider>
    </Dialog>
  );
};

export const BankStatementsBrokerModal = memo(
  BankStatementsBrokerModalComponent,
);
